<template>
  <header class="main-header">
    <div class="outer-container">
      <div class="container">
        <div class="main-box clearfix">
          <div class="logo-box">
            <figure class="logo"><router-link to="/"><img src="images/home/logo.png" class="logo-w" alt="logo"></router-link></figure>
          </div>
          <div class="nav-outer clearfix">
            <div class="menu-area">
              <nav class="main-menu navbar-expand-lg">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                </div>
                <div class="navbar-collapse collapse clearfix">
                  <ul class="navigation clearfix">
                    <li class="current"><router-link to="/">Home</router-link></li>
                    <li class="dropdown pointer"><a @click.prevent="navigateAbout">About</a></li>
                    <li class="dropdown pointer"><a @click.prevent="navigateToHowToPlay">How To Play</a></li>
                    <li class="dropdown pointer"><a @click.prevent="navigateToFeatures">Features</a></li>
                    <li class="dropdown pointer"><a @click.prevent="navigateContact">Contact</a></li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky-header">
      <div class="container clearfix">
        <figure class="logo-box"><router-link to="/"><img src="images/home/logo.png" alt="logo"></router-link></figure>
        <div class="menu-area">
          <nav class="main-menu navbar-expand-lg">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="navbar-collapse collapse clearfix">
              <ul class="navigation clearfix">
                <li class="current"><router-link to="/">Home</router-link></li>
                <li class="dropdown pointer"><a @click.prevent="navigateAbout">About</a></li>
                <li class="dropdown pointer"><a @click.prevent="navigateToHowToPlay">How To Play</a></li>
                <li class="dropdown pointer"><a @click.prevent="navigateToFeatures">Features</a></li>
                <li class="dropdown pointer"><a @click.prevent="navigateContact">Contact</a></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
  <div id="mainbody">
    <router-view/>
  </div>
  <footer class="main-footer" style="background-image: url(images/background/footer-bg.png);">
    <div class="container">
      <div class="footer-top">
        <div class="widget-section">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
              <div class="logo-widget footer-widget">
                <figure class="footer-logo"><router-link to="/"><img src="images/home/logo.png" alt=""></router-link></figure>
                <div class="widget-content">
                  <div class="text">FantasyEcho.com is an online fantasy platform crafted for cricket enthusiasts to demonstrate their knowledge and strategic skills.</div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
              <div class="links-widget footer-widget">
                <h4 class="widget-title">Useful Links</h4>
                <div class="widget-content">
                  <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li class="pointer"><a @click.prevent="navigateAbout">About</a></li>
                    <li class="pointer"><a @click.prevent="navigateToHowToPlay">How To Play</a></li>
                    <li class="pointer"><a @click.prevent="navigateToFeatures">Features</a></li>
                    <li class="pointer"><a @click.prevent="navigateContact">Contact</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
              <div class="links-widget footer-widget">
                <h4 class="widget-title">Policy</h4>
                <div class="widget-content">
                  <ul>
                    <li><router-link :to="{name:'PrivacyPolicy'}">Privacy Policy</router-link></li>
                    <li><router-link :to="{name:'TermsAndCondition'}">Terms & Conditions</router-link></li>
                    <li><router-link :to="{name:'RefundAndCancellation'}">Refund & Cancellation</router-link></li>
                    <li><router-link :to="{name:'GameRules'}">Game Rules</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom clearfix text-center">
        <div class="copyright">Copyright © 2025 FantasyEcho</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LayoutView",
  methods: {
    navigateToHowToPlay() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#how_it_work' });
      } else {
        const element = document.querySelector('#how_it_work');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateToFeatures() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#features' });
      } else {
        const element = document.querySelector('#features');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateAbout(){
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#about' });
      } else {
        const element = document.querySelector('#about');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    navigateContact(){
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: '#contact' });
      } else {
        const element = document.querySelector('#contact');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }
}
</script>

<style scoped>
.compny{
  width: 250px;
}
.pointer{
  cursor: pointer;
}
@media (max-width: 991px) {
  .compny{
    width: 220px;
  }
}
@media (max-width: 576px) {
  .logo-w{
    width: 150px;
  }
}
</style>
